<div id="show-video" class="videoflotante">
    <div id="sourceVideo" class=" flex-container">
        <div id="btnCerrar" class="btn_cerrar" (click)="btnCerrar()"> 
            <p>x</p> 
        </div>
        <div>
            <video class="video" [autoplay]="true" controls>
                <source src="" type="video/mp4">
            </video>
        </div>
    </div>
</div>